import { Linkedin, Github } from "lucide-react";

const XIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const SOCIALS = [
  { href: "https://www.linkedin.com/in/rajeshvaishnav7/", label: "LinkedIn", Icon: Linkedin },
  { href: "https://github.com/rajeshvaishnav123", label: "GitHub", Icon: Github },
  { href: "https://x.com/ssrvaishnav7", label: "X", Icon: XIcon },
];

const SocialLinks = ({ size = 16, testPrefix = "social" }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
    {SOCIALS.map(({ href, label, Icon }) => (
      <a key={label} href={href} target="_blank" rel="noopener" aria-label={label} title={label}
        className="social-icon" data-testid={`${testPrefix}-${label.toLowerCase()}`}>
        <Icon size={size} />
      </a>
    ))}
  </div>
);

export default SocialLinks;
